import { render } from "./ButtonGoCreate.vue?vue&type=template&id=a925401e"
import script from "./ButtonGoCreate.vue?vue&type=script&lang=js"
export * from "./ButtonGoCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/di-di.biz/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__